import { DependencyList, useEffect, useRef } from "react";

export function useScrollIntoView<T extends HTMLElement>(
  delay?: number,
  scrollOptions?: ScrollIntoViewOptions,
  dependencies: DependencyList = []
) {
  const ref = useRef<T>(null);

  useEffect(() => {
    const timerId = setTimeout(() => {
      ref.current?.scrollIntoView(scrollOptions);
    }, delay);
    return () => clearTimeout(timerId);
  }, [ref.current, ...dependencies]);

  return ref;
}
